export const comments_3464720 = {"data":{"data":[],"links":{}}}